<template>
  <div>
    <v-head></v-head>
    <div class="more_bg">
      <img src="../assets/pic02.png" alt="">
      <div class="more_txt">
        <div class="title">
           智能AI
        </div>
        <div class="txt">
          Intelligent AI
        </div>
      </div>
    </div>
    <div class="more_content">
      <div class="more_left">
        <img src="../assets/pic51.png" alt="">
      </div>
      <div class="more_right">
        <div class="maxTitle">电站无人值守自主移动巡检机器人</div>
        <div class="more_wrap">
          <div class="title">产品介绍</div>
          <div class="txt">
            <p>
            无人值守巡检机器人是一种工作在无人值守环境下，代替巡检人员完成设备状态的巡检及数据记录的机器人，对机械结构灵活性、稳定性和定位准确性、实时性要求较高，国内外针对巡检机器人方案有很多，大部分都有着结构不合理，运动不可靠，定位不实时，精度不高或性能不稳定的缺点。
            </p> 
本产品针对无人值守巡检机器人提出了一套机械结构和定位策略的设计方案和配套的控制策略，可以使机器人实现稳定灵活的运动动作，并且能够准确实时的获取自身空间位置，所提出的方案显著改善了无人值守巡检机器人的巡检作业性能，具备市场推广价值，对促进变电站安全稳定运行，提高供电可靠性具有重要意义，其应用前景广阔。
          </div>
          <div class="title">相关案例</div>
          <img src='../assets/pic52.png' alt="" @click="gotoDetail">
          <div class="txt last">电站无人值守自主移动巡检机器人</div>
        </div>
      </div>
    </div>
    <div class="more_detail">
      <div class="title_wrap">
        <div class="title">
          产品详情
        </div>
        <div class="mini_title">
          DETAILS
        </div>
      </div>
      <div class="box">
        <div class="more_top">
          <div class="more_list begin">
            <div class="title">灵活可配置巡检方式</div>
            <div class="en">Flexible and configurable inspection methods</div>
            <div class="txt"><span class="el-icon-caret-right"></span>1)周期巡检全部设备：机器人自动定位，对配电室
              内所有电柜进行循环监视、拍照、摄像及参数识别
              记录；
              2)特定路径巡检：通过配置巡检路径，实现对配电
              室内某些电柜进行循环监视、拍照、摄像及参数识
              别记录；
              3)定时巡检：机器人系统根据设定的巡检周期，自
              动执行巡检任务。</div>
            
          </div> 
          <div class="more_list begin">
            <div class="title">定位方式</div>
            <div class="en">Positioning method</div>
            <div class="txt"><span class="el-icon-caret-right"></span>不同于其他巡检机器人采用复杂传感器（编码器或接
              近开关）定位的方式，该设备采用不依赖于任何传感
              器完全依靠WIFI定位和机器视觉识别定位的方式，排
              除了因传感器故障导致定位失败的可能性，凭借反复
              验证、成熟可靠的基于机器视觉定位策略得出设备的
              空间位置，灵活可配置，定位精度高，具有较高的平
              衡控制能力、抗干扰能力和容错能力。</div>
          </div>
          
          <div class="more_list last begin">
            <div class="title">安全保障</div>
            <div class="en">Safety and security</div>
            <div class="txt"><span class="el-icon-caret-right"></span>1）智能防撞，遇到障碍自动停止，防止碰撞造成人
              员及设备损伤；
              2）安全定点充电功能（接触式防打火安全分布式充
              电站配合蓄电池）；
              3）控制终端对巡检数据及传感器采集数据进行实时
              监视，对异常数据进行分级报警。</div>
          </div>
        </div>
        <div class="more_top end">
          <div class="more_list">
            <div class="title">特色功能</div>
            <div class="en">Featured Features</div>
            <div class="txt"><span class="el-icon-caret-right"></span>1）手动/自动控制模式灵活切换，工作人员可打断
              机器人自动巡检模式，远程手动控制巡视，退出手
              动模式后，机器人自动复位，继续巡检工作；
              2）智能充电：氧气含量传感器、环境温度传感器、
              湿度传感器、烟雾传感器、有害气体含量传感器等，
              实时监测变电站环境状况；
              3）配备多个红外成像模块，可以实时监测中部及
              两侧设备温度状况，温度异常情况下进行分级报警，
              并可结合高清摄像头进行故障定位及诊断；
              4）配备本地独立数据库进行数据的存储及读取，
              控制终端预留对电站内网接口，实现巡检数据的共享；
              5）降低维护成本：巡检机器人整体机械结构采用
              模块化结构设计，红外成像模块采用了FLIR公司的
              Lepton成像模块，设计了可靠的基础平台，这样既
              降低了成本又为二次开发提供了多样的选择，算法
              上采用了静态路径规划，这种算法错误率非常低，
              可以自己计算并寻找最优路径。</div>
          </div> 
          <div class="more_list">
            <div class="title">基于实物ID的深化应用</div>
            <div class="en">Deepening the application based</div>
            <div class="txt"><span class="el-icon-caret-right"></span>1）基于实物ID的设备智能巡检：
    电站智能巡检机器人在正常工作中需要对巡检
    设备进行认知，常规的手段是通过人为配置建
    立设备信息来实现，这种方式配置繁琐工作量
    大，且发生设备变更后还需人员维护。然而利
    用智能扫描识别手段可以有效的解决这个问题，
    提高实物ID的应用范围和价值。
2）基于实物ID的设备台帐智能维护：
     在台帐维护环节通过利用智能巡检机器人台帐
     维护功能，从PMS等上端系统根据实物ID信息
     获取设备变更申请单及铭牌信息，将巡检设备
     情况、故障记录通过数据接口发送给对应的上
     端平台。
3）基于实物ID的智能化资产盘点：
     将手持式设备微应用部分功能集成至智能机器
     人设备上，巡检过程中即可进行实物ID标签信
     息与PMS设备台帐匹配，记录资产盘点结果，
     也可单独执行资产盘点任务。</div>
          </div> 
        </div>
      </div>
    </div>
    <div class="more_down">
      <div class="title_wrap">
        <div class="title">
          相关下载
        </div>
        <div class="mini_title">
          DOWNLOAD
        </div>
      </div>
      <div>
        <img src="../assets/code.png" alt="">
      </div>
    </div>
    <v-foot class="more_foot"></v-foot>
  </div>
</template>
<script>
import router from '../router/index.js'
export default {
  methods: {
    gotoHome() {
      router.push('/')
    },
    gotoDetail() {
      router.push('/detail8')
    }
  }
}
</script>
<style scoped>

.head {
  position: absolute;
  background-color: #000;
  height: 75px;
  top: 0;
  width: 100%;
}
.head img {
  margin-top: 10px;
  width: 55px;
  height: 57px;
  margin-left: 20px;
}
.more_bg img {
  margin-top: 75px;
  width: 100%;  
  height: 600px;  
}
.more_txt {
  position: absolute;
  top: 260px;
  right: 420px;
  color: #fff ;
}
.more_txt .title {
  font-size: 58px;
}
.more_txt .txt {
  margin-top: 32px;
  font-size: 32px;
}
.more_text {
  display: flex;
}

.more_content {
  display: flex;
  margin-top: 30px;
  justify-content: center;
  width: 70%;
  align-items: center;
  margin: 0 auto;
  padding-top: 80px;
}
.more_left img{
  width: 420px;
  height: 360px;
}
.more_right {
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-left: 50px;
}
.more_right img {
  width: 210px;
  height: 120px;
}
.more_right .maxTitle {
  font-size: 28px;
  color: #333;
  font-weight: 600;
}
.more_right .title {
  margin: 15px 0;
  font-size: 22px;
  color: #333;
  font-weight: 600;
}
.more_right .txt {
  font-size: 15px;
  color: #333;
}
.more_wrap {
  width: 550px;
  border-top: 1px solid #333;
  margin: 15px 0;
}
.more_wrap .last {
  margin-top: 10px;
}
.more_detail {
  width: 1000px;
  margin: 0 auto;
}
.more_detail .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
}
.more_detail .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_detail .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_detail .more_top {
  display: flex;
}
.more_top .more_list {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 300px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 20px 10px;

}
.end .more_list {
  width: 280px;
  padding: 20px 10px;
  margin-top: 20px;
}
.more_detail .last {
  margin-right: 0;
}
.more_detail .begin {
  margin-bottom: 50px;
}
.more_detail .more_list .title {
  font-size: 18px;
  font-weight: 600;
}
.more_detail .more_list .en {
  font-size: 14px;
  padding: 10px 0;
  color: #bbb;
}
.more_detail .more_list .txt {
  font-size: 14px;
  color: #333;
  display: flex;
}
.el-icon-caret-right {
  margin-top: 5px;
  color: #333;
}
.more_detail .more_bottom {
  border: 1px solid #dee;
  box-shadow: 1px 1px 1px 1px #eee;
  margin-right: 50px;
  width: 280px;
  display: flex;
  justify-content: center;
  flex-direction: column;
  margin-top: 30px;
  padding: 30px 10px;


}
.more_down {
  width: 1000px;
  margin: 0 auto;
}
.more_down .title {
  color: #333;
  font-size: 26px;
  font-weight: 600;
  margin-top: 60px;
}
.more_down .mini_title {
  font-size: 18px;
  color: #ccc;
  margin-top: 10px;
}
.more_down .title_wrap {
  border-bottom: 1px solid #ccc;
  padding-bottom: 20px;
  margin-bottom: 45px;
}
.more_foot {
  margin-top: 50px;
}

</style>


// WEBPACK FOOTER //
// src/components/MoreInfor7.vue